/* React */
import React from "react";
/* thorium-ui */
import { Block } from "thorium-ui";
/* Images */
import profile from "../../assets/images/profile";

export const ProfileImage = () => {
   return (
      <Block
         xs={12}
         sm={12}
         md={9}
         lg={6}
         xl={4}
         style={{ alignSelf: "center" }}
         justify="center"
         className="animate fade slideY"
      >
         <img
            srcSet={`${profile.webp.sm} 1x, ${profile.png.sm} 1x, ${profile.webp.md} 2x, ${profile.png.md} 2x`}
            alt="profile"
            key="profile-img"
            className="profile-img"
         />
      </Block>
   );
};

export default ProfileImage;
